import { Loader2 } from "lucide-react"
import { useEffect, useState } from "react"

const ItemCover = ({
  cover,
  name,
  size = 64,
  loading,
}: {
  cover: string
  name?: string
  size?: number
  loading?: boolean
}) => {
  const [hasError, setHasError] = useState(false)
  const imageSrc = !hasError && cover && cover !== "<nil>" ? cover : "/none-image.svg"

  useEffect(() => {
    setHasError(false)
  }, [cover])

  return (
    <div
      className="flex items-center justify-center overflow-hidden"
      style={{ width: size, height: size }}
    >
      {loading && (!cover || cover === "<nil>") ? (
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      ) : (
        <img
          alt={hasError || !cover || cover === "<nil>" ? "No image" : name}
          src={imageSrc}
          className="h-full w-full object-contain"
          style={{ width: size, height: size }}
          onError={() => setHasError(true)}
        />
      )}
    </div>
  )
}

export default ItemCover
